var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "client-devices" },
    [
      _c("el-card", [
        _c(
          "div",
          {
            staticClass: "clearfix",
            attrs: { slot: "header" },
            slot: "header",
          },
          [
            _c("span", { staticClass: "header-item" }, [
              _vm._v(_vm._s(_vm.$t("client_devices.title"))),
            ]),
            _vm._v(" "),
            _c(
              "span",
              { staticClass: "ring-card__header-buttons" },
              [
                _c(
                  "UnlinkDevices",
                  {
                    directives: [
                      {
                        name: "acl",
                        rawName: "v-acl.enable",
                        value: { permission: "unlink", on: "ClientDevices" },
                        expression:
                          "{permission: 'unlink', on:'ClientDevices'}",
                        modifiers: { enable: true },
                      },
                    ],
                    attrs: { "customer-id": _vm.customerId },
                    on: { onSucceed: _vm.fetch },
                  },
                  [_c("span", [_vm._v("Unlink All")])]
                ),
                _vm._v(" "),
                _c("el-divider", { attrs: { direction: "vertical" } }),
                _vm._v(" "),
                _c("RefreshButton", {
                  nativeOn: {
                    click: function ($event) {
                      return _vm.fetch(true)
                    },
                  },
                }),
              ],
              1
            ),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "card-content" },
          [
            _c(
              "el-table",
              {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.ajax.working,
                    expression: "ajax.working",
                  },
                ],
                ref: "clientDevicesTable",
                staticClass: "client-device-table",
                attrs: { data: _vm.clientDevices },
                on: {
                  "expand-change": _vm.onExpandRow,
                  "cell-click": _vm.toggleRowExpansion,
                },
              },
              [
                _c("el-table-column", {
                  attrs: { type: "expand" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c(
                            "ul",
                            {
                              staticStyle: {
                                margin: "0",
                                padding: "0 50px",
                                "list-style": "none",
                              },
                            },
                            _vm._l(
                              scope.row.metadata,
                              function (value, key, index) {
                                return _c(
                                  "li",
                                  {
                                    key: index,
                                    staticStyle: {
                                      float: "left",
                                      width: "50%",
                                      margin: "5px -10px",
                                      padding: "5px 10px",
                                    },
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticStyle: {
                                          display: "flex",
                                          "justify-content": "space-between",
                                        },
                                      },
                                      [
                                        _c(
                                          "strong",
                                          { staticStyle: { flex: "1" } },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.startCase(key)) + ":  "
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          { staticStyle: { flex: "2" } },
                                          [_vm._v(_vm._s(value))]
                                        ),
                                      ]
                                    ),
                                  ]
                                )
                              }
                            ),
                            0
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _vm._l(_vm.metaTable, function (column) {
                  return _vm.showColumn({ id: column.id })
                    ? _c("el-table-column", {
                        key: column.prop,
                        attrs: {
                          prop: column.prop,
                          width: column.width,
                          label: column.label,
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c("section", [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(
                                          _vm.get(scope.row, column.prop, "")
                                        ) +
                                        "\n            "
                                    ),
                                  ]),
                                ]
                              },
                            },
                          ],
                          null,
                          true
                        ),
                      })
                    : _vm._e()
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    "min-width": "20",
                    align: "center",
                    label: "Passkey Enabled",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          scope.row.passkey &&
                          scope.row.passkey.enabled === true
                            ? _c("i", {
                                staticClass: "el-icon-check",
                                staticStyle: {
                                  "font-size": "large",
                                  "font-weight": "bold",
                                },
                              })
                            : _vm._e(),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    "min-width": "20",
                    align: "center",
                    label: _vm.$t("client_devices.signed_in"),
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c(
                            "el-tooltip",
                            {
                              attrs: {
                                effect: "dark",
                                placement: "top",
                                content: scope.row.signed_in
                                  ? "Customer signed in"
                                  : "Customer not signed in yet.",
                              },
                            },
                            [
                              _c("i", {
                                class: scope.row.signed_in
                                  ? "el-icon-check"
                                  : "el-icon-close",
                                staticStyle: {
                                  "font-size": "large",
                                  "font-weight": "bold",
                                },
                              }),
                            ]
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    "min-width": "30",
                    align: "center",
                    label: _vm.$t("client_devices.allows_screensharing"),
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("i", {
                            class: scope.row.screensharing
                              ? "el-icon-check"
                              : "el-icon-close",
                            staticStyle: {
                              "font-size": "large",
                              "font-weight": "bold",
                            },
                          }),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "hardware_id",
                    label: "Actions",
                    width: "120",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          scope.row.hardware_id
                            ? _c(
                                "div",
                                [
                                  _c(
                                    "UnlinkDevices",
                                    {
                                      directives: [
                                        {
                                          name: "acl",
                                          rawName: "v-acl.enable",
                                          value: {
                                            permission: "unlink",
                                            on: "ClientDevices",
                                          },
                                          expression:
                                            "{permission: 'unlink', on:'ClientDevices'}",
                                          modifiers: { enable: true },
                                        },
                                      ],
                                      attrs: {
                                        "device-id": scope.row.hardware_id,
                                        "customer-id": _vm.customerId,
                                        "app-brand": scope.row.app_brand,
                                        tooltip: "Unlink Device",
                                      },
                                      on: { onSucceed: _vm.fetch },
                                    },
                                    [_c("i", { staticClass: "el-icon-delete" })]
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ]
                      },
                    },
                  ]),
                }),
              ],
              2
            ),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }